module.exports = __webpack_public_path__ + "static/media/header.f27e9adb.mp3";